import { render } from "./OverviewLayout.vue?vue&type=template&id=20f34cf0"
import script from "./OverviewLayout.vue?vue&type=script&lang=js"
export * from "./OverviewLayout.vue?vue&type=script&lang=js"

import "./OverviewLayout.vue?vue&type=style&index=0&id=20f34cf0&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__